<template lang="">
  <v-dialog v-model="dialog.state" width="600px">
    <v-card>
      <v-card-text class="py-5 pb-10">
        <h2 class="text-uppercase">{{ dialog.title }}</h2>
        <div v-html="dialog.text" class="mt-4"></div>
      </v-card-text>
      <v-divider class="mb-6" />
      <v-card-actions class="px-6 py-3" v-if="dialog.type === 'delete'">
        <v-btn depressed color="error" class="px-6 mr-4 mt-n4 mb-2 white--text" @click="done">{{
          dialog.okText || 'Xác Nhận'
        }}</v-btn>
        <v-spacer />
        <v-btn depressed outlined color="grey darken-1" class="px-6 ml-4 mt-n4 mb-2 white--text" @click="cancel">{{
          dialog.cancelText || 'Hủy'
        }}</v-btn>
      </v-card-actions>

      <v-card-actions class="px-6 py-3" v-else>
        <v-btn depressed outlined color="grey darken-1" class="px-6 mr-4 mt-n4 mb-2 white--text" @click="cancel">{{
          dialog.cancelText || 'Hủy'
        }}</v-btn>
        <v-spacer />
        <v-btn depressed color="primary" class="px-6 ml-4 mt-n4 mb-2 white--text" @click="done">{{
          dialog.okText || 'Xác Nhận'
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialog: this.$dialog.confirmData,
    }
  },
  methods: {
    done() {
      this.dialog.done()
      this.cancel()
    },
    cancel() {
      this.$dialog.cancel()
    },
  },
}
</script>
